<!-- Navbar Simple -->
<nav class="login-navbar">
  <div class="navbar-container">
    <div class="navbar-logo">
      <img src="assets/images/file.png" alt="Logo" height="40">
      <span class="logo-text">Brokins</span>
    </div>
    <button class="home-button" (click)="goToHome()">
      <i class="pi pi-home"></i>
      <span>Accueil</span>
    </button>
  </div>
</nav>

<div class="login-page-fullscreen">
  <!-- Left Side - Brand & Features -->
  <div class="left-panel">
    <div class="brand-section">
      <div class="logo-circle">
        <span class="material-icons">account_balance</span>
      </div>
      <h1 class="brand-title">Brokins</h1>
      <p class="brand-subtitle">Comparateur d'assurance</p>
    </div>



    <div class="features-section">
      <div class="feature-box">
        <span class="material-icons">speed</span>
        <div class="feature-text">
          <h3>Rapide</h3>
          <p>Comparez en quelques clics</p>
        </div>
      </div>
      <div class="feature-box">
        <span class="material-icons">security</span>
        <div class="feature-text">
          <h3>Sécurisé</h3>
          <p>Données protégées à 100%</p>
        </div>
      </div>
      <div class="feature-box">
        <span class="material-icons">savings</span>
        <div class="feature-text">
          <h3>Économique</h3>
          <p>Meilleurs tarifs garantis</p>
  
        </div>
        
      </div>
    </div>        
          <br>
          <br>
          <br>
         
  </div>

  <!-- Right Side - Login Form -->
  <div class="right-panel">
    <div class="form-wrapper">
      <div class="form-header">
        <h2>Bienvenue ! 👋</h2>
        <p>Connectez-vous pour accéder à votre espace</p>
      </div>

      <form (ngSubmit)="onSubmit()" class="modern-form">
        <!-- Email -->
        <div class="form-field">
          <label>Adresse email</label>
          <div class="input-container">
            <span class="material-icons input-icon">mail_outline</span>
            <input
              type="email"
              name="username"
              [(ngModel)]="form.username"
              placeholder="votre@email.com"
              required
            />
          </div>
        </div>

        <!-- Password -->
        <div class="form-field">
          <label>Mot de passe</label>
          <div class="input-container password-container">
            <span class="material-icons input-icon">lock_outline</span>
            <input
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              [(ngModel)]="form.password"
              placeholder="••••••••"
              required
            />
            <button type="button" class="password-toggle" (click)="togglePassword()" tabindex="-1">
              <span class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
            </button>
          </div>
        </div>

        <!-- Options -->
        <div class="form-row">
          <label class="checkbox-label">
            <input type="checkbox" />
            <span>Se souvenir de moi</span>
          </label>
          <a href="#" class="link-forgot">Mot de passe oublié ?</a>
        </div>

        <!-- Error -->
        <div class="alert-error" *ngIf="error">
          <span class="material-icons">error_outline</span>
          <span>{{ error }}</span>
        </div>

        <!-- Submit -->
        <button type="submit" class="btn-primary">
          <span class="material-icons">login</span>
          <span>Se connecter</span>
        </button>

        <!-- Divider -->
        <div class="divider">
          <span>OU</span>
        </div>

        <!-- HubSpot -->
        <button type="button" class="btn-secondary" (click)="loginWithHubSpot()">
          <span class="material-icons">hub</span>
          <span>Continuer avec HubSpot</span>
        </button>

        <!-- Register -->
      </form>

      <!-- Footer -->
      <div class="security-footer">
        <span class="material-icons">verified_user</span>
        <span>Connexion sécurisée SSL</span>
      </div>
    </div>
  </div>

  <!-- Register Modal -->
  <app-register 
    [(visible)]="showRegisterModal"
    (registerSuccess)="onRegisterSuccess()">
  </app-register>
</div>

<!-- Footer -->
<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-brand">
        <div class="footer-logo">
          <span class="footer-logo-text">Brokins</span>
        </div>
        <p class="footer-description">
          Courtier en Assurances<br>
          Conseil Les Assurances<br>
          75004 Paris<br>
          FRANCE
        </p>
      </div>

      <div class="footer-links">
        <div class="footer-column">
          <h4>Nos Assurances</h4>
          <a>Assurance des Personnes pour Particuliers</a>
          <a>Assurance des Personnes pour Professionnels</a>
          <a>Assurance des Biens pour Particuliers</a>
          <a>Assurance des Biens pour Entreprises</a>
          <a>Assurance de l'Activité des Professionnels</a>
          <a>Autre Assurances</a>
        </div>

        <div class="footer-column">
          <h4>Pourquoi Brokins ?</h4>
          <a>Qui sommes-nous</a>
          <a>Avis et Commentaires Clients</a>
          <a>Avantages d'Espace Client</a>
          <a>Notre Equipe</a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <p>Politique de Confidentialité | Informations Légales | Mentions Légales | Conditions de vente | RGPD © 2023 Cabinet Les Assurances</p>
      <div class="footer-social">
        <a href="#" target="_blank"><i class="pi pi-facebook"></i></a>
        <a href="#" target="_blank"><i class="pi pi-twitter"></i></a>
        <a href="#" target="_blank"><i class="pi pi-linkedin"></i></a>
        <a href="#" target="_blank"><i class="pi pi-youtube"></i></a>
      </div>
    </div>
  </div>
</footer>
